<template>
    <router-link :to="url" class="theme-btn default-btn" :class="classname">
        {{title}}
    </router-link>
</template>

<script>
    export default {
        name: "Button",
        props: ['title', 'url', 'classname']
    }
</script>

<style scoped>

</style>